import { Controller } from "@hotwired/stimulus"

// Use this controller within turbo responses that update the content of a modal to close it, add the controller on
// an empty span.
//
// This controller will search for the closest ".modal" element and will call modal hide on it to hide the modal.
export default class extends Controller {
  connect() {
    $(this.element.closest(".modal")).modal("hide")
    this.element.remove()
  }
}
